import React from 'react';
import './_dropdown_toggle.scss';
import { useTranslation } from 'react-i18next';

const Dropdown = (props) => {
    const { t } = useTranslation();
    const translatedSelected = (!props.selected || props.selected === "" || props.selected === "全部單位") ? t("GLOBAL.BED_STATE.ALL") : props.selected;

    const translatedKeys = props?.data?.keys.map((key, index) =>
        index === 0 && key === "全部單位" ? t("GLOBAL.BED_STATE.ALL") : key
    );
    return (
        <div className="wrap-dropdown">
            <div className={`dropdown ${props.closeToggle ? 'active' : ''}`}
                onClick={props.toggleDropdown}
                onMouseLeave={(props.closeToggle) ? props.toggleDropdown : null}>
                <div className="fx-d-r">
                    <div className={`${props.layout ? 'w-20' : 'wid-30'} fx-ccc`}>
                        <div className={`tri ${props.closeToggle ? 'rotate' : ''}`}></div>
                    </div>
                    <div className="dropdown_header">
                        <div className="fx-ccc"
                            data-index={props.index}
                            data-group="dropdown">
                            <span className="dropdown_selected_text">
                                {translatedSelected}
                            </span>
                        </div>
                        {!props.layout ? <div className="line"></div> : null}
                    </div>
                </div>

                <div className={`fx-d-c ${!props.layout ? "fx-nnfe" : ""}`}>
                    <div className={`dropdown_body ${!props.layout ? "" : "w-100"} ${props.closeToggle ? 'active' : 'none'}`}>
                        <div className="div_display">
                            {
                                translatedKeys.map((dcg, index) =>
                                    <ul id={`${props.data.id}-${index}`}
                                        key={`${props.data.id}-${index}`}
                                        onClick={() => props.returnData(props.data.keys[index])}
                                    >
                                        <li>
                                            <div className={`dropdown-item`}
                                                id={`${props.data.id}-item_${props.toggle_index}-${index}`}
                                                key={`${props.data.id}-item_${props.toggle_index}-${index}`}
                                                href="#"
                                            >{dcg}</div>
                                        </li>
                                    </ul>
                                )
                            }
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Dropdown;